import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'cass-terms-and-conditions-dialog',
	templateUrl: './terms-and-conditions-dialog.component.html',
	styleUrls: ['./terms-and-conditions-dialog.component.css']
})
export class TermsAndConditionsDialogComponent {

	constructor (@Inject(MAT_DIALOG_DATA) public data: { safeHtmlContent: SafeHtml, useAccept: boolean }) { }
}
